export const resources = {
    app: {
        label_login: 'Log In',
        label_logout: 'Log Out'
    },
    component: {
        status_overlay: {
            title: 'Loading…'
        },
        upload_manager: {
            err_fragments_merge: 'Fragments merge error',
            err_fragments_not_all_uploaded: 'Not all fragments were uploaded',
            err_fragments_upload: 'Fragments upload error',
            status_merged: 'Merged',
            status_merging: 'Merging',
            status_uploaded: 'Uploaded',
            status_uploading: 'Uploading'
        }
    },
    control: {
        combobox: {
            empty_value: {
                none: '(none)',
                not_specified: '(not specified)',
                select: '(select)'
            }
        }
    },
    data: {
        validations: {
            array_value: {
                error: 'The value must be an array of values.'
            },
            between: {
                error: 'The value must be equal to or greater than {min} and equal to or less than {max}.'
            },
            codelist_value: {
                error: 'The value must be a value from the codelist.'
            },
            datetime_parse: {
                error: 'The value must match the expected date/time format.'
            },
            datetime_range: {
                error: 'The value must be within the allowed date/time range.'
            },
            email_address: {
                error: 'The value must be an email address.'
            },
            equal: {
                error: 'The value must be equal to {expected}.'
            },
            float_value: {
                required: 'The value must be a decimal number.'
            },
            greater_than: {
                error: 'The value must be greater than {expected}.'
            },
            greater_than_or_equal: {
                error: 'The value must be equal to or greater than {expected}.'
            },
            int_value: {
                error: 'The value must be an integer.'
            },
            less_than: {
                error: 'The value must be less than {expected}.'
            },
            less_than_or_equal: {
                error: 'The value must be equal to or less than {expected}.'
            },
            not_equal: {
                error: 'The value must not be equal to {expected}.'
            },
            required: {
                error: 'A value is required.'
            },
            string_value: {
                error: 'The value must be text.'
            }
        },
        value: {
            false: 'false',
            true: 'yes',
            undefined: 'N/A'
        }
    },
    module: {
        account: {
            btn_change_password: 'Change Password',
            btn_reset_password: 'Reset Password',
            btn_verify: 'Verify',
            email_verification_error: 'An application error occurred while verifying your email. Please repeat your request later.',
            email_verification_fail: 'Your email could not be verified.',
            email_verification_msg: 'Your email is being verified.',
            email_verification_success: 'Your email has been successfully verified.',
            email_verification_title: 'E-mail Verification',
            lbl_back_to_login_page: 'Back to Log In page',
            msg_password_changed: 'The password has been changed.',
            msg_proceed_to_login_page: 'Proceed to Log In page',
            password_reset_error: 'An application error occurred while resetting your password. Please repeat your request later.',
            password_reset_fail: 'Your password could not be changed. The password reset link has expired or the link has already been used.',
            password_reset_instructions: 'Please enter the reset code, your new login password and the new login password verification.',
            password_reset_start_instructions: 'Please enter the email you used to register.',
            password_reset_start_success: 'Password reset has been successfully initiated.',
            password_reset_start_success_instructions: 'A message with a link to complete the password reset process has been sent to the e-mail indicated in the previous step. After receiving the message, please follow the instructions.',
            password_reset_success: 'Your password has been changed.',
            password_reset_success_msg: 'You can now log in.',
            password_reset_title: 'Password Reset',
            registration_email_verification_msg: 'Your email address is being verified.',
            registration_email_verification_success_msg: 'By verifying the email address, the registration process has been completed. You can now log in.',
            registration_email_verification_sucess: 'Your email address has been successfully verified.',
            registration_error: 'An application error occurred while creating your account. Please repeat your request later.',
            registration_fail: 'Your account could not be created.',
            registration_success: 'Your account was created successfully.',
            registration_success_msg: 'To complete the registration, it is necessary to verify your e-mail address. Therefore, a message containing a verification code has been sent to you. After receiving the message, please follow the instructions in the message.',
            registration_title: 'Registration',
            title_account_details: 'Account Details',
            title_password_change: 'Password Change',
            title_personal_information: 'Personal Infromation'
        },
        auth: {
            btn_login: 'Log In',
            lbl_back_to_login_page: 'Back to Log In page',
            lbl_password: 'Password',
            lbl_register: 'Register',
            lbl_reset_password: 'Reset Password',
            lbl_username: 'Username',
            msg_logged_out: 'You have been logged out.',
            msg_logging_out: 'Logging out…',
            title_logged_out: 'Log Out',
            title_login: 'Log In'
        },
        data_browser: {
            hint_orderable_column: 'Click: sort by this column. Ctrl+Click: add this column to multiple sorting.',
            msg_drop_unsaved_changes_confirmation: 'Really discard unsaved changes?',
            msg_record_delete_confirmation: 'Are you sure you want to delete the %{name} record?',
            msg_records_delete_confirmation: 'Are you sure you want to delete records %{names}?',
            title_new_record: 'New Record',
            title_record_delete: 'Rocord Delete',
            title_records_delete: 'Multiple Records Delete',
            title_unsaved_changes: 'Unsaved Changes'
        }
    },
    page: {
        error_401: {
            description: 'You are not logged into the application.',
            recommendation: 'Please use login page and try open requested module again. Eventually contact the project administrator.',
            title: 'Unauthorized (#401)'
        },
        error_403: {
            description: 'You don\'t have sufficient privileges to use the requested module.',
            recommendation: 'This error usually appears in situations where you don\'t have granted any application role. Please <b>contact the project administrator</b> to assign you an application role.',
            title: 'Forbidden (#403)'
        },
        error_404: {
            description: 'The module you are looking for was not found.',
            recommendation: 'Please check URL address in your browser, there could be a typo. Eventually contact the project administrator.',
            title: 'Not found (#404)'
        }
    }
};
